import { Link } from "react-router-dom";
import type { Work } from "@/mocks/works";
import Highlight from "./Highlight";

interface WorkCardProps {
  work: Work;
  keyword?: string;
}

export default function WorkCard({ work, keyword = "" }: WorkCardProps) {
  return (
    <Link
      to={`/works/${work.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="w-full h-64 overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={`影视作品《${work.title}》海报`}
          title={`${work.title} - 濑户环奈影视作品`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col gap-2 p-4">
        <div className="flex items-center gap-2">
          <span className="px-2 py-0.5 rounded-full text-[11px] font-medium bg-primary-100 text-primary-700">
            {work.type}
          </span>
          <span className="text-xs text-foreground-500">{work.year}</span>
        </div>
        <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
          <Highlight text={`《${work.title}》`} keyword={keyword} />
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          <Highlight text={work.summary} keyword={keyword} />
        </p>
      </div>
    </Link>
  );
}